const closeIcon = () => '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.625 1.6832L10.3168 0.375L6 4.6918L1.6832 0.375L0.375 1.6832L4.6918 6L0.375 10.3168L1.6832 11.625L6 7.3082L10.3168 11.625L11.625 10.3168L7.3082 6L11.625 1.6832Z" fill="currentColor"/> </svg>';

export default closeIcon;
